import { Visibility, VisibilityOff } from '@mui/icons-material';
import { Button, InputAdornment, Stack, Typography } from '@mui/material';
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { USER_LOGIN_DATA, WOH_AM_I_DATA } from '../../api/url';
import { MuiInput } from '../../components';
import { getUserByIdentityIdAPI, loginAPI, whoAmIAPI } from "../../redux/authSlice";
import { setReducerState } from '../../redux/crudSlice';
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { deleteLocalStorageItem, getWhoAmIToken } from "../../utils/storageHelper";
import { useDynamicForm } from '../../components/formBuilder/useDynamicForm';


const initialFValues = {
    Username: "",
    Password: "",
};

const Login = () => {

    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const loginData = useAppSelector(state => state.auth.loginData);
    const [auth, setAuth] = useState(false);
    const [isPasswordVisible, setIsPasswordVisible] = useState(false);


    useEffect(() => {
        window.onpopstate = function (event) {
            window.history.go(1);
        }
        autoLogin(loginData);

        dispatch(setReducerState({ key: 'activeRoutes', value: null }))
        localStorage.removeItem("Subscription");
    }, [])

    const togglePassword = (e: any) => {
        e.preventDefault();
        setIsPasswordVisible(!isPasswordVisible);
    };

    const validate = (fieldValues = values) => { };

    const { values, setValues, errors, setErrors } = useDynamicForm(
        initialFValues,
        true,
        validate
    );

    const autoLogin = async (loginData: any) => {
        if (loginData?.data?.Token) {
            const { data: { IdentityId } } = loginData
            const res: any = await dispatch(getUserByIdentityIdAPI(IdentityId));
            if (res?.payload?.success) {
                navigate('/dashboard');
                return;
            }
            deleteLocalStorageItem(USER_LOGIN_DATA);
            deleteLocalStorageItem(WOH_AM_I_DATA);
        }
        let whoAmIToken = getWhoAmIToken();
        if (!whoAmIToken) {
            const res = await dispatch(whoAmIAPI());
        }
        setAuth(true);
    }

    const handleLogin = async (e: any) => {
        e.preventDefault();
        const result: any = await dispatch(loginAPI(values))
        if (result?.payload?.statusCode === 200) {
            navigate("/dashboard");
            deleteLocalStorageItem(WOH_AM_I_DATA);
        }
    };

    const onInputChange = (e: any) => {
        const { name, value } = e.target;
        let str: any = /\s/g.test(value)
        setValues({
            ...values,
            [name]: value,
        });
        if (str) {
            setErrors({ ...errors, [name]: `Space are not allowed in ${name}` })
        } else {
            setErrors({})
        }
    }

    return (auth ?
        <Stack component='form' onSubmit={handleLogin} height='100%' alignItems='center' justifyContent='center' >
            <Stack direction='column' width='100%' maxWidth={400} gap={2} p={3} >
                <Typography variant='h1' align='center'>
                    Sign In
                </Typography>

                <MuiInput
                    label={"User name"}
                    name="Username"
                    placeholder="Enter username"
                    value={values.Username}
                    error={errors.Username}
                    fullWidth
                    onInputChange={onInputChange}
                />

                <MuiInput
                    label={"Password"}
                    name="Password"
                    placeholder="Enter password"
                    type={isPasswordVisible ? "text" : "password"}
                    value={values.Password}
                    error={errors.Password}
                    onInputChange={onInputChange}
                    fullWidth
                    slotProps={{
                        input: {
                            endAdornment: (
                                <InputAdornment
                                    position="end"
                                    onClick={(e) => {
                                        togglePassword(e);
                                    }}
                                    sx={{ cursor: 'pointer' }}
                                >
                                    {isPasswordVisible && (
                                        <Visibility />
                                    )}
                                    {!isPasswordVisible && (
                                        <VisibilityOff />
                                    )}
                                </InputAdornment>
                            ),
                        }
                    }}
                />

                <Button
                    disabled={!(values.Username && values.Password && !errors?.Username && !errors?.Password)}
                    variant="contained"
                    type="submit"
                    size="medium"
                    children="Sign In"
                />
            </Stack>
        </Stack> : null
    );
}

export default Login